import React from "react";
import "../components/Box.css";

const Box = ({ course, className, onViewAllClick, currentCourse,completedCourse,joinedCourse,newEnquiryCourse }) => {
  
  return (
    <div className={`boxbd p20 ${className}`}>
      <div className="v-center">
        <p className="fs16 fw5 fc8 lh22 df jcsb w100">
          {course.courseName}
          {currentCourse.includes(course.courseId) ? (
            <span className="fw6 ls1 fc9">(Active)</span>
          ) : (
            ""
          )}
          {completedCourse.includes(course.courseId) ? (
            <span className="fw6 ls1 fc7  ">(Completed)</span>
          ) : (
            ""
          )}
	 {joinedCourse.includes(course.courseId) ? (
            <span className="fw6 ls1 fc12">(Joined)</span>
          ) : (
            ""
          )}

          {newEnquiryCourse.includes(course.courseId) ? (
            <span className="fw6 ls1 fc12">(Enroll Now)</span>
          ) : (
            ""
          )}
          
        </p>
      </div>
      <div className="plan mt16">
        <ul className="pl16 list-unstyled fs14">
          {course.courseHighlights && Object.keys(course.courseHighlights).map((key) => (
            <li className="mb8 fc16 lh22 ls1" key={key}>
              {key}: {course.courseHighlights[key]}
            </li>
          ))}
        </ul>
      </div>
      
      {course.coursePrice.INR.gstprice &&(
      <div id="price" className="mt16 fc17">
        <div className="df w100 mt16 mb8">
          {/* <div className="box-center fdc">
            <p className="label fc8 fs14 ls1 lh18 mb4 fw6">Course Fee</p>
            <p className="value fc6 fs16 ls1 lh18">
              ₹{course.coursePrice.INR.price}
            </p>
          </div>

          <div className="box-center fdc ml12">
            <p className="label fc8 fs18 ls1 lh18">+</p>
          </div>
          <div className="box-center fdc ml12">
            <p className="label fc8 fs14 ls1 lh18 mb4 fw6">GST (18%)</p>
            <p className="value fc6 fs16 ls1 lh18">₹{course.coursePrice.INR.gstprice}</p>
          </div> 


          <div className="box-center fdc ml12">
            <p className="label fc8 fs18 ls1 lh18">=</p>
          </div> */}


          <div className="box-center fdc ml12">
          <p className="label fc8 fs14 ls1 lh18 fw6">Total Fee =</p>
          </div>

          <div className="box-center fdc ml12">
            {/* <p className="label fc8 fs14 ls1 lh18 mb4 fw6">Total Price</p> */}
            <p className="value total-price fc3 ml4 fs20">₹{course.coursePrice.INR.totalprice}</p>
          </div>
        </div>
      </div>
      )}

      <div className="df jce mt12 ls3 aic">
        <p className="fs14 cp tdu fc3" onClick={() => onViewAllClick(course)}>
          View
        </p>
      </div>
    </div>
  );
};

export default Box;

